export default __webpack_public_path__ + "static/artificial-intelligence-hero-robot-0f6c0d93c8eea99a731a771a7c32a5c8.png";